import React from "react";
import { Button, Container } from "reactstrap";

const ErrorState = ({ error, color, onRetry, title = "Failed to load unit details" }) => (
  <div className="page-content">
    <Container fluid>
      <div className="text-center mt-5">
        <div
          className="alert alert-danger p-4 shadow-sm border-0"
          style={{ borderRadius: "12px" }}
        >
          <i className="ri-error-warning-line fs-1 d-block mb-3"></i>
          <h4 className="mb-3">{title}</h4>
          <p className="mb-4">{error}</p>
          <Button
            style={{
              backgroundColor: color,
              borderColor: color,
              padding: "10px 24px",
              borderRadius: "8px",
            }}
            onClick={onRetry}
          >
            <i className="ri-refresh-line me-1"></i> Retry
          </Button>
        </div>
      </div>
    </Container>
  </div>
);

export default ErrorState;
